import type { Phase } from "../lib/types";
import { INTRO, ctaLabel, statusLine } from "../lib/verdict";

interface HeroProps {
  phase: Phase;
  count: number;
  runMs: number;
  lit: number;
  found: number;
  stopped: boolean;
  onRun: () => void;
  onStop: () => void;
}

export function Hero({ phase, count, runMs, lit, found, stopped, onRun, onStop }: HeroProps) {
  const runSeconds = Math.max(1, Math.round(runMs / 1000));
  const running = phase === "running";
  return (
    <header
      data-rt-hero=""
      style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14, paddingTop: 52, textAlign: "center", width: "100%" }}
    >
      <h1
        style={{
          margin: 0, fontFamily: "'Sora', sans-serif", fontWeight: 700,
          fontSize: "clamp(32px, 7vw, 46px)", lineHeight: 1.08, letterSpacing: "-0.02em", color: "#DEDFDF", textWrap: "balance",
        }}
      >
        DNS Leak Test
      </h1>
      <a href="https://rapidtunnel.com" style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 11, fontWeight: 800, letterSpacing: "0.24em", textTransform: "uppercase", color: "#DCF300", textDecoration: "none" }}>
        <span style={{ color: "#8A8D88", fontWeight: 700 }}>Sponsored by</span>
        <img src="/assets/logo-rapidtunnel.png" alt="RapidTunnel" style={{ height: 18, display: "block" }} />
      </a>
      <p style={{ margin: "6px 0 0", maxWidth: 520, fontSize: 14.5, lineHeight: 1.6, color: "#8A8D88", textWrap: "pretty", fontWeight: 400 }}>
        {INTRO}
      </p>
      <div data-rt-ctarow="" style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 12 }}>
        <button
          data-cta=""
          data-running={running ? "on" : "off"}
          onClick={running ? onStop : onRun}
          aria-label={running ? "Stop the test" : undefined}
          style={{
            border: "none", cursor: "pointer", background: running ? "#141614" : "#DCF300", color: running ? "#DCF300" : "#0A0B0A",
            outline: running ? "1.5px solid rgba(220,243,0,0.5)" : "none",
            fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, fontWeight: 800,
            padding: "15px 32px", minHeight: 50, borderRadius: 999,
            boxShadow: running ? "none" : "0 0 22px rgba(220,243,0,0.28)", transition: "all 160ms cubic-bezier(0.2,0,0,1)",
          }}
        >
          {ctaLabel(phase)}
        </button>
      </div>
      <span style={{ fontFamily: "'Space Mono', monospace", fontSize: 14, color: "var(--rt-white)" }}>
        Run Time: ~{runSeconds}s
      </span>
      <div aria-live="polite" style={{ fontFamily: "'Space Mono', monospace", fontSize: 12, color: "var(--status-secure)", minHeight: 18, letterSpacing: "0.04em" }}>
        {statusLine(phase, lit, count, found, stopped)}
      </div>
    </header>
  );
}
